module.exports = __webpack_public_path__ + "static/media/adresa.4ef44d92.svg";